const SET_CURRENT_KPI = 'SET_CURRENT_KPI'
const SET_CURRENT_SOURCE = 'SET_CURRENT_SOURCE'
const SET_CURRENT_DISTRIBUTION = 'SET_CURRENT_DISTRIBUTION'
const SET_CURRENT_DISTANCE = 'SET_CURRENT_DISTANCE'
const SET_ACTIVE_FILTERS = 'SET_ACTIVE_FILTERS'
const SET_ACTIVE_BRANDS = 'SET_ACTIVE_BRANDS'
const SET_ACTIVE_GROUPS = 'SET_ACTIVE_GROUPS'
const SET_CURRENT_COUNTRIES = 'SET_CURRENT_COUNTRIES'
const SET_CURRENT_SECTORS = 'SET_CURRENT_SECTORS'
const SET_ALL_BRANDS = 'SET_ALL_BRANDS'
const SET_ALL_GROUPS = 'SET_ALL_GROUPS'
const SET_CURRENT_TIMELINE = 'SET_CURRENT_TIMELINE'

const state = () => {
  return {
    currentKpi: '',
    currentSource: null,
    currentDistribution: null,
    currentDistance: 0,
    currentCountries: null,
    currentSectors: [],
    currentTimeline: '',
    activeFilters: null,
    activeBrands: null,
    activeGroups: null,
    allBrands: false,
    allGroupsBrands: false,
  }
}

const mutations = {
  [SET_CURRENT_KPI]: (state, kpi) => {
    state.currentKpi = kpi
  },
  [SET_CURRENT_SOURCE]: (state, source) => {
    state.currentSource = source
  },
  [SET_CURRENT_DISTRIBUTION]: (state, distribution) => {
    state.currentDistribution = distribution
  },
  [SET_CURRENT_DISTANCE]: (state, distance) => {
    state.currentDistance = distance
  },
  [SET_CURRENT_COUNTRIES]: (state, countries) => {
    state.currentCountries = countries
  },
  [SET_CURRENT_SECTORS]: (state, sectors) => {
    state.currentSectors = sectors
  },
  [SET_CURRENT_TIMELINE]: (state, timeline) => {
    state.currentTimeline = timeline
  },
  [SET_ACTIVE_BRANDS]: (state, brands) => {
    state.activeBrands = brands
  },
  [SET_ACTIVE_GROUPS]: (state, groups) => {
    state.activeGroups = groups
  },
  [SET_ACTIVE_FILTERS]: (state, filters) => {
    state.activeFilters = filters
  },
  [SET_ALL_BRANDS]: (state, bool) => {
    state.allBrands = bool
  },
  [SET_ALL_GROUPS]: (state, bool) => {
    state.allGroupsBrands = bool
  },
}

const actions = {
  initCurrentKpi: ({ commit, state }, { settings, query = '' }) => {
    const currentKpi = query.kpis ? query.kpis : settings[0].key
    if (checkAvailableKpi(settings, currentKpi)) {
      commit(SET_CURRENT_KPI, currentKpi)
      return Promise.resolve(state.currentKpi)
    }
    return Promise.reject('Unknown KPI')
  },
  initCurrentCountries: ({ commit, state }, { countries, setting, query = '' }) => {
    const currentCountries = query.countries
      ? query.countries.split(',')
      : setting.default_country
      ? setting.default_country
      : [countries[0].key]
    if (currentCountries.length) {
      if (checkAvailableCountries(countries, currentCountries)) {
        commit(SET_CURRENT_COUNTRIES, currentCountries)
        return Promise.resolve(state.currentCountries)
      }
      return Promise.reject('Unknown Countries')
    }
    return Promise.resolve()
  },
  initCurrentSource: ({ commit, state }, { sources, query = '' }) => {
    const currentSource = query.sources
      ? query.sources
      : sources.length > 1 || sources.length === 0
      ? 'all'
      : sources[0].key
    if (checkAvailableSource(sources, currentSource)) {
      commit(SET_CURRENT_SOURCE, currentSource)
      return Promise.resolve(state.currentSource)
    }
    return Promise.reject('Unknown Source')
  },
  resetCurrentSource: ({ dispatch, state }, sources) => {
    if (!checkAvailableSource(sources, state.currentSource)) {
      return dispatch('initCurrentSource', { sources })
    }
    return Promise.resolve()
  },
  initCurrentDistribution: ({ commit }, { distribution, query = '' }) => {
    commit(SET_CURRENT_DISTRIBUTION, null)
    const currentDistribution = query.distribution ? query.distribution.split(',') : []
    if (distribution) {
      if (currentDistribution.length == 2 && checkAvailableDistribution(distribution, currentDistribution)) {
        commit(SET_CURRENT_DISTRIBUTION, currentDistribution)
        return Promise.resolve()
      } else if (checkAvailableDistribution(distribution, [distribution.min, distribution.max])) {
        commit(SET_CURRENT_DISTRIBUTION, [distribution.min, distribution.max])
        return Promise.resolve()
      }
      return Promise.reject('Unkown Distribution')
    }
    return Promise.resolve()
  },
  initActiveBrands: ({ commit }, { brands, query = '' }) => {
    let activeGroups = query.groups?.split(',')
    if (activeGroups) {
      commit(SET_ACTIVE_GROUPS, activeGroups)
    }
    let activeBrands = query.brands
      ? query.brands.split(',').map(brand => encodeURIComponent(brand).replace(/'/g, '%27'))
      : brands.filter(brand => brand.brand.brand_status).map(brand => brand.brand.key)
    if (query.all_brands) {
      activeBrands = brands.map(brand => brand.brand.key)
      commit(SET_ACTIVE_BRANDS, activeBrands)
      commit(SET_ALL_BRANDS, true)
      return Promise.resolve()
    }
    if (checkAvailableBrands(brands, activeBrands)) {
      commit(SET_ACTIVE_BRANDS, activeBrands)
      return Promise.resolve()
    }
    return Promise.reject('Unknown Brands')
  },
  initActiveFilters: ({ commit }, { filters, query = '' }) => {
    if (filters.length) {
      const activeFilters = query.filters ? query.filters.split(',') : filters.map(filter => filter.key)
      if (checkAvailableFilters(filters, activeFilters)) {
        commit(SET_ACTIVE_FILTERS, activeFilters)
        return Promise.resolve()
      }
      return Promise.reject('Unkown Filters')
    }
    return Promise.resolve()
  },
  updateCurrentKpi: ({ commit }, kpi) => {
    commit(SET_CURRENT_KPI, kpi)
  },
  updateCurrentSource: ({ commit }, source) => {
    commit(SET_CURRENT_SOURCE, source)
  },
  updateCurrentDistribution: ({ commit }, distribution) => {
    commit(SET_CURRENT_DISTRIBUTION, distribution)
  },
  updateCurrentDistance: ({ commit }, distance) => {
    if (distance) {
      commit(SET_CURRENT_DISTANCE, distance)
    }
  },
  updateCurrentTimeline: ({ commit }, timeline) => {
    if (timeline) {
      commit(SET_CURRENT_TIMELINE, timeline)
    }
  },
  updateActiveFilters: ({ commit }, filters) => {
    commit(SET_ACTIVE_FILTERS, filters)
  },
  updateActiveBrands: ({ commit }, brands) => {
    commit(SET_ACTIVE_BRANDS, brands)
  },
  updateActiveGroups: ({ commit }, groups) => {
    commit(SET_ACTIVE_GROUPS, groups)
  },
  updateCurrentCountries: ({ commit }, countries) => {
    commit(SET_CURRENT_COUNTRIES, countries)
  },
  updateCurrentSectors: ({ commit }, countries) => {
    commit(SET_CURRENT_SECTORS, countries)
  },
  toggleAllBrands: ({ commit }, { bool, brands = [] }) => {
    commit(SET_ALL_BRANDS, bool)
    if (bool && brands.length > 0) {
      const activeBrands = brands.map(brand => brand.brand.key)
      commit(SET_ACTIVE_BRANDS, activeBrands)
    } else if (!bool && brands.length > 0) {
      commit(SET_ACTIVE_BRANDS, [])
    }
  },
  toggleAllGroupsBrands: ({ commit }, { groupTabIsActive, brands = [] }) => {
    commit(SET_ALL_GROUPS, groupTabIsActive)
    if (groupTabIsActive && brands.groups.length > 0) {
      const activeGroups = brands.groups.map(group => group.brand.key)
      commit(SET_ACTIVE_GROUPS, activeGroups)
    } else if (!groupTabIsActive && brands.groups.length > 0) {
      commit(SET_ACTIVE_GROUPS, [])
    }
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}

function checkAvailableSource(sources, currentSource) {
  if (currentSource === 'all') {
    return true
  }
  const sameSource = sources.filter(source => source.key === currentSource)
  return sameSource.length > 0
}

function checkAvailableDistribution(distribution, currentDistribution) {
  return distribution.min <= currentDistribution[0] && distribution.max >= currentDistribution[1]
}

function checkAvailableBrands(brands, activeBrands) {
  const sameBrands = brands.filter(brand => activeBrands.includes(brand.brand.key))
  return sameBrands.length > 0
}

function checkAvailableFilters(filters, activeFilters) {
  const sameFilters = filters.filter(filter => activeFilters.includes(filter.key))
  return sameFilters.length > 0
}

function checkAvailableKpi(settings, currentKpi) {
  const sameKpi = settings.filter(setting => setting.key === currentKpi)
  return sameKpi.length > 0
}

function checkAvailableCountries(countries, currentCountries) {
  const sameCountries = countries.filter(country => currentCountries.includes(country.key))
  return sameCountries.length > 0
}
